import { useState } from "react";

export interface DragPreviewState {
  id: string;
  tempStartDate: Date;
  tempEndDate: Date;
}

export const useDragPreviewState = () => {
  const [dragPreview, setDragPreview] = useState<DragPreviewState | null>(null);

  return {
    dragPreview,
    setDragPreview,
  };
};
